// Quiz endpoints
export const QUIZ_ENDPOINTS = {
  LIST: '/api/v1/Quizzes',
  GET: (id: string | number) => `/api/v1/Quizzes/${id}`,
  START: (id: string | number) => `/api/v1/Quizzes/${id}/start`,
  CREATE: '/api/v1/Quizzes',
  UPDATE: (id: string | number) => `/api/v1/Quizzes/${id}`,
  DELETE: (id: string | number) => `/api/v1/Quizzes/${id}`,
  PUBLISH: (id: string | number) => `/api/v1/Quizzes/${id}/publish`,
};

// Assessment endpoints
export const ASSESSMENT_ENDPOINTS = {
  LIST: '/api/v1/Assessments',
  GET: (id: string) => `/api/v1/Assessments/${id}`,
  DELETE: (id: string | number) => `/api/v1/Assessments/${id}`,
  CREATE: '/api/v1/Assessments',
  SESSION: '/api/v1/Assessments/session',
  DRAFT: '/api/v1/Assessments/draft',
  SUBMIT: (id: string) => `/api/v1/Assessments/${id}/submit`,
  EXPORT: '/api/v1/Assessments/export',
};

// Question endpoints
export const QUESTION_ENDPOINTS = {
  CREATE: (quizId: number) => `/api/v1/Quizzes/${quizId}/Questions`,
  UPDATE: (quizId: number, questionId: number) =>
    `/api/v1/Quizzes/${quizId}/Questions/${questionId}`,
  DELETE: (quizId: number, questionId: number) =>
    `/api/v1/Quizzes/${quizId}/Questions/${questionId}`,
};

// User endpoints
export const USER_ENDPOINTS = {
  LIST: '/api/v1/Users',
  CREATE: '/api/v1/Users',
  UPDATE: (id: number) => `/api/v1/Users/${id}`,
  DELETE: (id: number) => `/api/v1/Users/${id}`,
};

// Health check
export const HEALTH_ENDPOINT = '/health';

export const RECAPTCHA_ENDPOINTS = {
  VERIFY: '/api/v1/Recaptcha/verify',
};

// AI endpoints
export const AI_ENDPOINTS = {
  PROCESS_ANSWER: '/api/v1/ai/process-answer',
};
